import { areValuesEqual } from '@/utils/form-state.utils';

export const findEditedFields = <T extends object>(current: T, loaded: T): Array<keyof T> => {
  const fields = [...new Set([...Object.keys(loaded), ...Object.keys(current)])] as Array<keyof T>;
  return fields.filter(field => !areValuesEqual(current[field], loaded[field]));
};
